<template>
  <div>
    <div class="table-wrapper orders-history">
      <section class="section">
        <div class="section-contents pt-1">
          <div class="row">
            <div class="col-lg-12 profile-details">
              <h2 class="cp-title">
                Your Shipping Addresses
                <button
                  class="btn btn-sm btn-outline-success float-right"
                  @click="addShipping"
                >
                  Add New
                </button>
                <div class="clearfix"></div>
              </h2>
              <div class="table-responsive">
                <table class="table table-striped table-hover">
                  <tbody>
                    <tr v-for="(row, key) in addresses" v-bind:key="key">
                      <th scope="row">
                        <div>{{ row.first_name }} ({{ row.phone }})</div>

                        <div>
                          {{ row.address_1 }}, {{ row.city.name }},
                          {{ row.zip_code }}
                        </div>

                        <div>{{ row.city.name }}</div>
                      </th>
                      <td class="text-right">
                        <button
                          class="btn btn-info btn-sm"
                          @click="edit(row)"
                        >
                             <i class="fa fa-pencil"></i>
                        </button>
                                <!-- <button
                                title="remove address"
                          class="btn btn-danger ml-1 btn-sm"
                          @click="removeAddress(row)"
                        >
                          <i class="fa fa-trash"></i>
                        </button> -->
                      </td>
                    </tr>
                    <tr v-if="notFound">
                      <th scope="row" colspan="2">
                        No data found
                      </th>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div class="modal" id="addDelivery" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <form method="post" @submit="addShippingAddress">
              <div class="modal-header">
                <h5 class="modal-title">নতুন ঠিকানা যোগ করুন</h5>
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body ">
                <div class="row">
                  <div class="form-group col-lg-6">
                    <label>নাম<span class="required">&nbsp;*</span></label>
                    <input
                      type="text"
                      ref="first_name"
                      v-model="formData.first_name"
                      class="form-control"
                      placeholder="নাম"
                      autocomplete="off"
                    />
                  </div>

                  <div class="form-group col-lg-6">
                    <label
                      >মোবাইল নাম্বার<span class="required"
                        >&nbsp;*</span
                      ></label
                    >
                    <div class="input-group mb-2">
                      <div class="input-group-prepend">
                        <span class="input-group-text">+88</span>
                      </div>
                      <input
                        type="number"
                        ref="phone"
                        v-model="formData.phone"
                        class="form-control hide-arrow"
                        placeholder="মোবাইল নাম্বার"
                        autocomplete="off"
                      />
                    </div>
                  </div>

                  <div class="form-group col-lg-6">
                    <label>অঞ্চল<span class="required">&nbsp;*</span></label>
                    <select
                      ref="region_id"
                      v-model="formData.region_id"
                      class="form-control"
                      autocomplete="off"
                      @change="getCity"
                    >
                      <option value="">অঞ্চল</option>
                      <option
                        v-for="(row, key) in region"
                        v-bind:key="key"
                        :value="`${row.id}`"
                        >{{ row.name }}</option
                      >
                    </select>
                  </div>

                  <div class="form-group col-lg-6">
                    <label>সিটি<span class="required">&nbsp;*</span></label>
                    <select
                      ref="city_id"
                      v-model="formData.city_id"
                      class="form-control"
                      @change="getArea"
                    >
                      <option value="">সিটি</option>
                      <option
                        v-for="(row, key) in city"
                        v-bind:key="key"
                        :value="`${row.id}`"
                        >{{ row.name }}</option
                      >
                    </select>
                  </div>

                  <div class="form-group col-lg-12">
                    <label>এরিয়া<span class="required">&nbsp;*</span></label>
                    <select
                      ref="area_id"
                      v-model="formData.area_id"
                      class="form-control"
                    >
                      <option value="">এরিয়া</option>
                      <option
                        v-for="(row, key) in area"
                        v-bind:key="key"
                        :value="`${row.id}`"
                        >{{ row.name }}</option
                      >
                    </select>
                  </div>

                  <div class="form-group col-lg-12">
                    <label>ঠিকানা<span class="required">&nbsp;*</span></label>
                    <input
                      type="text"
                      ref="address_1"
                      v-model="formData.address_1"
                      class="form-control"
                      placeholder="e.g: House# 01, Street# 01, ABC Road"
                      autocomplete="off"
                    />
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button type="submit" class="btn btn-primary">
                  সেভ করুন
                </button>
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                >
                  বন্ধ করুন
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  data() {
    return {
      notFound: false,
      addresses: null,
      formData: {
        region_id: "",
        city_id: "",
        area_id: ""
      },
      region: [],
      city: [],
      area: []
    };
  },
  methods: {
    addShipping() {
      $("#addDelivery").modal("show");
    },
    edit(row) {
      this.formData = row;
      $("#addDelivery").modal("show");
    },
    getRegion() {
      this.$authHttp
        .get("region")
        .then(response => {
          if (response.data.status) {
            this.region = response.data.region;
          }
        })
        .catch(e => {
          //  console.log(e);
        });
    },
    getCity() {
      this.$authHttp
        .get("city/" + this.formData.region_id)
        .then(response => {
          if (response.data.status) {
            this.city = response.data.city;
          }
        })
        .catch(error => {
          this.flashMessage.error({
            message: error.response.data.message
          });
        });
    },
    getArea() {
      this.$authHttp
        .get("area/" + this.formData.city_id)
        .then(response => {
          if (response.data.status) {
            this.area = response.data.area;
          }
        })
        .catch(e => {
          this.flashMessage.error({
            message: e.response.data.message
          });
        });
    },
    addShippingAddress: function(e) {
      e.preventDefault();

      if (!this.formData.first_name) {
        this.$refs.first_name.focus();
        this.flashMessage.error({ message: "নাম দিতে হবে" });
        return false;
      }
      if (!this.formData.phone) {
        this.$refs.phone.focus();
        this.flashMessage.error({ message: "মোবাইল নাম্বার দিতে হবে" });
        return false;
      }
      if (!this.$helper.validateMobileNo(this.formData.phone)) {
        this.$refs.phone.focus();
        this.flashMessage.error({ message: "আপনি ভুল মোবাইল নাম্বার দিয়েছেন" });
        return false;
      }

      if (!this.formData.region_id) {
        this.$refs.region_id.focus();
        this.flashMessage.error({ message: "অঞ্চল দিতে হবে" });
        return false;
      }
      if (!this.formData.city_id) {
        this.$refs.city_id.focus();
        this.flashMessage.error({ message: "সিটি দিতে হবে" });
        return false;
      }
      if (!this.formData.area_id) {
        this.$refs.area_id.focus();
        this.flashMessage.error({ message: "এরিয়া দিতে হবে" });
        return false;
      }
      if (!this.formData.address_1) {
        this.$refs.address_1.focus();
        this.flashMessage.error({ message: "ঠিকানা দিতে হবে" });
        return false;
      }

      if (this.formData.id) {
        this.updateShipping(this.formData);
      } else {
        this.storeShipping(this.formData);
      }
    },
    storeShipping(formData) {
      this.formData.customer_id = localStorage.getItem("customer_id");
      this.$authHttp
        .post("customer-shipping-address", formData)
        .then(response => {
          if (response.data.status) {
            this.flashMessage.success({
              message: "Address created successfully."
            });
            this.getShippingAddresses();
            $("#addDelivery").modal("hide");
            this.formData = { first_name: "" };
          } else {
            this.flashMessage.error({
              message: response.data.message
            });
          }
        })
        .catch(e => {
          if (e.response) {
            this.flashMessage.error({
              message: e.response.data.message
            });
          }
        });
    },
    edit(row) {
      this.formData = row;
      this.getCity();
      this.getArea();
      $("#addDelivery").modal("show");
    },
    updateShipping(formData) {
      this.$authHttp
        .put("customer-shipping-address/" + formData.id, formData)
        .then(response => {
          this.flashMessage.success({
            message: "Address updated successfully."
          });
          this.getShippingAddresses();
          $("#addDelivery").modal("hide");
        })
        .catch(e => {
          this.flashMessage.error({
            message: e.response.data.message
          });
        });
    },
    getShippingAddresses() {
      this.$authHttp
        .get("getShippingAddress")
        .then(response => {
          this.addresses = response.data;
          if (this.addresses.length < 1) this.notFound = true;
        })
        .catch(e => {
          console.log(e);
          this.notFound = true;
        });
    }
  },
  mounted() {
    this.getShippingAddresses();
    this.getRegion();
  }
};
</script>
